import React, {Component} from "react";
import Column from "@amzn/meridian/column";
import VaprDeviceOverviewContextProvider from "./context/VaprDeviceOverviewContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {VAPR} from "../../util/RouteConstants";

class VaprDevicePage extends Component {
    render() {
        return (
            <Column>
                <VaprDeviceOverviewContextProvider>
                    <TabLayout routes={VAPR} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={VAPR}/>
                </VaprDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default VaprDevicePage



// WEBPACK FOOTER //
// ./src/components/devicemanagement/vaprdevice/VaprDevicePage.js